import script from "./TutorialModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialModal.vue?vue&type=script&setup=true&lang=js"

import "./TutorialModal.vue?vue&type=style&index=0&id=4c655939&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c655939"]])

export default __exports__